import styled from 'styled-components';

export const RuleBuilderRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const ConditionRow = styled.div`
  display: grid;
  grid-template-columns: 1fr ${({ theme }) => theme.spacing(21)} 1fr ${({ theme }) => theme.spacing(4)};
  gap: ${({ theme }) => theme.spacing(1.5)};
  align-items: start;
`;

export const ValueCell = styled.div`
  min-width: 0;

  .MuiAutocomplete-inputRoot {
    flex-wrap: nowrap;
  }
`;

export const NoValuePlaceholder = styled.span`
  display: block;
  min-height: ${({ theme }) => theme.spacing(7)};
`;

export const ConditionRemove = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.spacing(4)};
  height: ${({ theme }) => theme.spacing(4)};
  margin-top: ${({ theme }) => theme.spacing(1.5)};
  border: none;
  background: transparent;
  border-radius: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.text.secondary};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.palette.action.hover};
  }

  &:disabled {
    color: ${({ theme }) => theme.palette.action.disabled};
    cursor: default;
    background: transparent;
  }
`;

export const ConditionJoin = styled.div`
  display: flex;
  align-items: center;
  min-height: ${({ theme }) => theme.spacing(4)};
`;

export const JoinToggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  padding: ${({ theme }) => theme.spacing(0.5)} ${({ theme }) => theme.spacing(1)};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.common.white};
  border-radius: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: ${({ theme }) => theme.typography.subtitle2.fontSize};
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.palette.action.hover};
  }
`;

export const JoinLabel = styled.span`
  padding: ${({ theme }) => theme.spacing(0.5)} ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.subtitle2.fontSize};
  font-weight: 500;
`;

export const RuleActions = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing(0.5)};
`;

export const AddConditionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  padding: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.palette.info.main};
  font-size: ${({ theme }) => theme.typography.subtitle2.fontSize};
  font-weight: 500;
  cursor: pointer;

  &:disabled {
    color: ${({ theme }) => theme.palette.action.disabled};
    cursor: default;
  }
`;

export const RuleLimitNote = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
`;

export const FieldError = styled.div`
  color: ${({ theme }) => theme.palette.error.main};
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
  margin-top: ${({ theme }) => theme.spacing(0.5)};
`;

// --- RuleSummary (read-mode chips) ---

export const RuleChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const RuleChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  padding: ${({ theme }) => theme.spacing(0.5)} ${({ theme }) => theme.spacing(1)};
  border: 1px solid ${({ theme }) => theme.ui.border.main};
  border-radius: ${({ theme }) => theme.spacing(0.75)};
  background: ${({ theme }) => theme.palette.grey[50]};
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
`;

export const RuleChipAttr = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const RuleChipValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ theme }) => theme.palette.text.primary};
  font-weight: 500;
`;

export const RuleChipMore = styled.button`
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.palette.info.main};
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
  font-weight: 500;
  cursor: pointer;
  padding: 0;
`;

export const RuleJoinWord = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
  font-weight: 600;
  text-transform: uppercase;
`;

export const RuleValueList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
  padding: ${({ theme }) => theme.spacing(1.5)};
  max-height: ${({ theme }) => theme.spacing(40)};
  overflow-y: auto;
`;

export const RuleValueListHeader = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
  font-weight: 600;
  margin-bottom: ${({ theme }) => theme.spacing(0.5)};
`;

export const RuleValueListItem = styled.div`
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
  color: ${({ theme }) => theme.palette.text.primary};
`;
